<template>
  <router-view />
</template>

<script>
export default {
  name: 'App',
  mounted() {
    this.checkSessionExpiration();
  },
  methods:{
    checkSessionExpiration() {
      const loginTime = localStorage.getItem('login_time');
      
      if (loginTime) {
        const twelveHoursInMs = 12 * 60 * 60 * 1000; // 12 jam dalam milidetik
        const currentTime = new Date().getTime();
        
        // Jika selisih waktu sekarang dengan waktu login sudah >= 12 jam
        if (currentTime - loginTime >= twelveHoursInMs) {
          this.logoutSession();
        } else {
          // Jika belum 12 jam, pasang sisa timer untuk otomatis logout
          const remainingTime = twelveHoursInMs - (currentTime - loginTime);
          setTimeout(() => {
            this.logoutSession();
          }, remainingTime);
        }
      }else if(!loginTime && localStorage.getItem('token')){
        this.logout();
      }
    },
    logoutSession() {
      localStorage.clear();
      
      if (this.$toasted) {
        this.$toasted.error("Sesi Anda telah habis. Silakan login kembali.");
      }
      
      if (this.$router.currentRoute.path !== '/login') {
        localStorage.setItem("baseapi","https://be.sea-v3.mysurvey.id/")
        this.$router.push('/login');
      }
    },
    logout() {
      localStorage.clear();
      
      if (this.$toasted) {
        this.$toasted.error("Silakan login kembali.");
      }
      
      if (this.$router.currentRoute.path !== '/login') {
        localStorage.setItem("baseapi","https://be.sea-v3.mysurvey.id/")
        this.$router.push('/login');
      }
    }
  }
};
</script>

<style src="./styles/theme.scss" lang="scss" />

<style>
.custom-disabled {
  background-color: white !important;   /* ubah warna background */
  color: black !important;              /* ubah warna teks */
  opacity: 1;                /* hilangkan efek pudar */
  cursor: not-allowed;       /* opsional, kasih tanda kursor */
}

/* merah muda untuk penolakan/perbaikan */
.row-tolak td {
  background-color: #fddede !important;
  color: #ff0019 !important;
}

.row-perbaikan {
  background-color: #f8d7da !important;
  color: #ff0019 !important;
}

/* hijau muda untuk terbit */
/* .row-setujui td {
  background-color: #d4f5dd !important;
  color: #00c12d !important;
} */

.loading-screen {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2000 !important;
  flex-direction: column;
  user-select: none;
}
.loading-circle {
  width: 50px;
  height: 50px;
  border-radius: 100%;
  border: 2px solid transparent;
  border-left-color: #ababab;
  animation: circleanimation 0.45s linear infinite;
}
.loading-text {
  margin-top: 15px;
  color: #808080;
  font-size: 12px;
  text-align: center;
}
@keyframes circleanimation {
  from {
    transform: rotateZ(0deg);
  }
  to {
    transform: rotateZ(360deg);
  }
}
</style>
